export const spinButtonTurboTextFontSizeMap: Record<string, number> = {
    ka: 16,
}
